module.exports = __webpack_public_path__ + "img/icon-master.1b6f734f.svg";